// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2IW9O","title":"Info_title__6wYWn","selects":"Info_selects__3pUkO","requiredAsterisk":"Info_requiredAsterisk__1uhnj"};